import {Component, forwardRef} from 'react';
import PropTypes from 'prop-types';
import uuidV4 from 'uuid/v4';

export default EnhancedComponent => {
    class WithPage extends Component {
        static propTypes = {
            data: PropTypes.object.isRequired,
            isNextDisabled: PropTypes.bool,
            isSelectedAnswerCorrect: PropTypes.bool,
            onSetNextDisabled: PropTypes.func,
            onShowDefinitions: PropTypes.func,
            onQuestionPageShown: PropTypes.func,
            forwardedRef: PropTypes.object,
        };

        _id = uuidV4();

        render() {
            const {forwardedRef, ...rest} = this.props;

            return (
                <div className="Page" tabIndex="0">
                    <div className="Page-content">
                        <EnhancedComponent
                            ref={forwardedRef}
                            uuid={this._id}
                            {...rest}
                        />
                    </div>
                </div>
            );
        }
    }

    return forwardRef((props, ref) => {
        // eslint-disable-line react/no-multi-comp
        return <WithPage forwardedRef={ref} {...props} />;
    });
};
